import Vue from "vue";
import { CallbackEvent } from '@/core/Utility/CallbackEvent.js';

export function SuccessModalController () {
    this.title = '';
    this.msg = '';
    this.btnOk = '';
    this.tag = '',
    this.busModal = new Vue();

    this.cbOk = new CallbackEvent();

    //#region setter
    this.setTitle = function(title) {
        this.title = title;
        return this;
    };
    this.setMsg = function(msg) {
        this.msg = msg;
        return this;
    };
    this.setBtnOk = function(btnOk) {
        this.btnOk = btnOk;
        return this;
    };
    this.setTag = function(tag) {
        this.tag = tag;
        return this;
    };
    this.clearModal = function() {
        this.title = '';
        this.msg = '';
        this.btnConfirm = '';
        this.btnCancel = '';
        this.tag = '';
        this.cbOk.clearCallback();

        return this;
    };
    //#endregion setter

    //#region method
    this.show = function() {
        var config = {
            title: this.title,
            msg: this.msg,
            btnOk: this.btnOk,
            tag: this.tag,
        };
        this.busModal.$emit('show', config);
    };
    this.hide = function() {
        this.busModal.$emit('hide');
    };
    //#endregion method
}
